export default {
    appParams: {
        thisActionDeleteParam: "Ця дія видалить цей параметр:",
        continue: "Продовжити",
        cancel: "Скасувати"
    },
    bases: {
        selectActionWithBase: "Виберіть дію з базою:",
        quanityOfTetheredApps: "Кількість прив'язаних програм:",
        selectAppsFromWhichUntieBase: "Виберіть програми, від яких відв'язати базу:",
        untieBaseOfSelectedApps: "Відв'язати базу з обраних програм",
        noAppsAttachedToBase: "До цієї бази не прив'язано програм",
        deleteBase: "Видалити базу",
        cancel: "Скасувати",
        thisActionDeleteBaseWholly: "Ця дія повністю видалить базу з відв'язуванням її від всіх програм. Продовжити?",
        cancellation: "Скасувати",
        selectAppForUntie: "Виберіть програму для відв'язування",
        selectOperation: "Виберіть операцію"
    },
    roles: {
        thisActionDeleteThisRole: "Ця дія видалить цю роль:",
        continue: "Продовжити",
        cancellation: "Скасувати",
    },
    sections: {
        selectAction: "Виберіть дію з програмою:",
        numberOfLinkedBases: "Кількість прив'язаних баз",
        selectBasesToUntie: "Виберіть бази, які відв'язати від програми",
        noUntiedBasesToThisApp: "До даної програми не прив'язано баз",
        deleteApp: "Видалити програму",
        cancel: "Скасувати",
        thisActionDeleteAppWholly: "Ця дія повністю видалить програму з відв'язуванням всіх баз та видаленням пов'язаних пакетів планувальника",
        basesAndPackets: "Баз прив'язано: {bases}, приймає участь в {packets} пакеті(-ах)",
        continue: "Продовжити",
        cancellation: "Скасувати",
        selectAppForUntie: "Виберіть програму для відв'язування",
        selectOption: "Виберіть операцію",
        selectAllBases: "Вибрати всі бази",
        unselectAllBases: "Очистити всі бази",
        untieSelectedBasesFromApp: "Відв'язати вибрані бази від програми"
    },
    servers: {
        versions: "Версії",
        hardwareInfo: "Ресурси",
        mainAgentVersion: "Версія головного агента",
        tinyAgentsVersions: "Версії tiny-агентів",
        thisActionDeleteServer: "Ця дія видалить цей сервер",
        continue: "Продовжити",
        attention: "Увага",
        cancellation: "Скасувати"
    },
    users: {
        errorYouCantDeleteDeveloper: "Помилка. Не можна видалити системного розробника",
        actionDeleteThisUser: "Ця дія видалить цього користувача",
        continue: "Продовжити",
        cancellation: "Скасувати"
    }
};